function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getElementType, getUnhandledProps } from '../../utils';
import css from './Tab.sass';

function Tab(props) {
  var className = props.className,
      children = props.children,
      active = props.active,
      theme = props.theme;
  var classNames = cx(css.root, active && css.active, theme && css[theme], className);
  var rest = getUnhandledProps(Tab, props);
  var ElementType = getElementType(Tab, props);
  if (ElementType.name === 'NavLink') Object.assign(rest, {
    activeClassName: css.active
  });
  return React.createElement(ElementType, _extends({}, rest, {
    className: classNames
  }), children);
}

Tab.displayName = 'Tabs.Tab';
Tab.propTypes = {
  /**
   * An element type to render as (string or function).
   */
  as:
  /*#__PURE__*/
  PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Primary content.
   */
  children: PropTypes.node,

  /**
   * Active tab.
   */
  active: PropTypes.bool,

  /**
   * Active tab.
   */
  activeClassName: PropTypes.string,

  /**
   * Active tab.
   */
  theme:
  /*#__PURE__*/
  PropTypes.oneOf(['compact', 'crispy', 'crispyCompact', 'rtk']),
  className: PropTypes.string
};
Tab.defaultProps = {
  as: 'div',
  activeClassName: css.active
};
export { Tab };